import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { CommonStyles } from '../../common/react/CommonStyles';
import { cssClass } from '../../style';


const cssPrefix = 'ConstantDataRoleDescriptorBlock';

const descriptorBlockClass = cssClass(cssPrefix, 'block', {
  paddingLeft: CommonStyles.Sizes.LargeSpace,
  paddingTop: CommonStyles.Sizes.MediumSpace,
  paddingRight: CommonStyles.Sizes.MediumSpace,
  fontSize: '13px',
  lineHeight: '1.5em',
});

const descriptorBlockTitleClass = cssClass(cssPrefix, 'title', {
  color: '#9B9B9B',
  paddingBottom: CommonStyles.Sizes.DefaultSpace,
});

export interface ConstDataRoleDescriptorBlockProps {
  title: string;
  content: JSX.Element | string;
}

export const ConstDataRoleDescriptorBlock: React.StatelessComponent<ConstDataRoleDescriptorBlockProps> = (props: ConstDataRoleDescriptorBlockProps) => {
  return <div className={descriptorBlockClass}>
    <div className={descriptorBlockTitleClass}>{props.title}</div>
    <div>{props.content}</div>
  </div>;
};

